import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { MarketWalletTrades } from "../api/types";

/**
 * Сделки ОДНОГО кошелька в ОДНОМ окне: как он набирал позицию.
 *
 * # Почему запрос ленивый
 *
 * Потому что платит за него чужой лимитер. Панель накопления опрашивается каждые
 * пять-пятнадцать секунд по каждому открытому рынку, и приезжай эти списки
 * вместе с ней — терминал ходил бы к индексатору за сотней историй, из которых
 * оператор смотрит одну. `enabled` включается раскрытием строки.
 *
 * # Почему такт редкий
 *
 * Полминуты: список отвечает на вопрос «как он набирал», а прошлое не меняется.
 * У ИДУЩЕГО окна хвост дописывается, но и там свежую сделку оператор видит в
 * ленте раньше, чем её проиндексирует источник (тот отстаёт минутами и рывками).
 */
const POLL_MS = 30_000;

export function marketWalletTradesKey(conditionID: string, wallet: string) {
  return ["market-wallet-trades", conditionID, wallet.toLowerCase()] as const;
}

export function useMarketWalletTrades(
  conditionID: string,
  wallet: string,
  enabled: boolean,
) {
  return useQuery<MarketWalletTrades>({
    queryKey: marketWalletTradesKey(conditionID, wallet),
    queryFn: () =>
      api.marketWalletTrades(conditionID, wallet).then((r) => r.wallet_trades),
    enabled: enabled && Boolean(conditionID) && Boolean(wallet),
    refetchInterval: POLL_MS,
    // Единственное место среди панелей рынка, где фоновый опрос ВЫКЛЮЧЕН
    // осознанно, и снимать этот false нельзя. У панели накопления и профиля
    // кошелька за опрос платит тёплый кеш и наш Postgres, а здесь — чужой
    // лимитер, поштучно за каждый раскрытый кошелёк. Забытая вкладка с десятью
    // раскрытыми строками ходила бы к индексатору двадцать раз в минуту ни за чем.
    refetchIntervalInBackground: false,
    // Свёрнутая и снова раскрытая строка не платит второго запроса: ответ живёт
    // в кеше ровно столько, сколько такт опроса.
    staleTime: POLL_MS,
  });
}
